import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { IReduxState, SingleColorType } from '../types';

interface IProps {
    backgroundColor: SingleColorType;
}

const Wrapper = styled.div<IProps>`
    background-color: ${(props) => props.backgroundColor};
    height: 100%;
    transition: background-color 0.3s ease-in-out;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

const BaseStepContainer: React.FC<IProps> = ({ backgroundColor, children }) => (
    <Wrapper backgroundColor={backgroundColor}>{children}</Wrapper>
);

const mapStateToProps = (state: IReduxState) => ({
    backgroundColor: state.backgroundColor,
});

export const StepContainer = connect(mapStateToProps)(BaseStepContainer);
